import toast from "react-hot-toast";
import { db } from "../config/firebaseConfig";
import { UserAuth } from "../context/authContext";
import DashboardLayout from "./layout/DashboardLayout";
import MainComponent from "./MainComponent";

const Dashboard = () => {
  const { userData, user, logout } = UserAuth();
  const copyToClipboard = (e, data) => {
    e.preventDefault(); // Prevent the default action associated with the event

    // Check if navigator.clipboard is available (HTTPS or localhost)
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(data).then(
        () => {
          toast.success("Copied Successfully");
        },
        (err) => {
          toast.error("Failed to copy");
        },
      );
    } else {
      // Fallback for HTTP or browsers without clipboard API
      const textArea = document.createElement("textarea");
      textArea.value = data;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          toast.success("Copied Successfully");
        } else {
          toast.error("Failed to copy");
        }
      } catch (err) {
        toast.error("Failed to copy");
      }
      document.body.removeChild(textArea);
    }
  };
  const createWallet = async () => {
    if (userData && userData.isWalletCreated) {
      toast.error("Wallet already created");
      return;
    }
    // update user doc in firebase
    await db.collection("users").doc(user.email).update({
      isWalletCreated: true,
    });

    toast.success("Wallet Created Successfully");
    window.location.reload();
  };
  return (
    <DashboardLayout>
      <MainComponent
        copyToClipboard={copyToClipboard}
        createWallet={createWallet}
        userData={userData}
        user={user}
        logout={logout}
      />
    </DashboardLayout>
  );
};

export default Dashboard;
